// =============================================================================
// RecommendedAuthApp — kolorowy box z polecaną aplikacją 2FA (2FAS):
// logo + QR do pobrania (iOS / Android) + linki do sklepów. Alternatywy wymienione.
// Assety: public/2fa/{logo2fa.webp,iosauth.png,android.png}
// =============================================================================

import { Apple, Play } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const IOS_URL = "https://apps.apple.com/us/app/2fa-authenticator-2fas/id1217793794";
const PLAY_URL = "https://play.google.com/store/apps/details?id=com.twofasapp";

const STORES = [
  { label: "iPhone (iOS)", qr: "/2fa/iosauth.png", url: IOS_URL, store: "App Store", Icon: Apple },
  { label: "Android", qr: "/2fa/android.png", url: PLAY_URL, store: "Google Play", Icon: Play },
];

export function RecommendedAuthApp() {
  return (
    <div className="rounded-md border border-indigo-200 bg-gradient-to-br from-indigo-50 to-purple-50 p-3 dark:border-indigo-800/50 dark:from-indigo-950/40 dark:to-purple-950/40">
      <div className="flex items-start gap-3">
        <img
          src="/2fa/logo2fa.webp"
          alt="2FAS Authenticator"
          className="h-10 w-10 shrink-0 rounded object-contain"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
        <div className="min-w-0 flex-1 space-y-0.5">
          <div className="flex items-center gap-1.5">
            <Badge className="bg-indigo-600 text-white hover:bg-indigo-600">Polecana</Badge>
            <span className="text-sm font-bold">2FAS Authenticator</span>
          </div>
          <p className="text-xs text-muted-foreground">Zeskanuj telefonem, aby pobrać aplikację:</p>
        </div>
      </div>

      <div className="mt-3 grid grid-cols-2 gap-2">
        {STORES.map(({ label, qr, url, store, Icon }) => (
          <div key={label} className="flex flex-col items-center gap-1.5">
            <span className="text-xs font-semibold">{label}</span>
            <div className="rounded-sm border bg-white p-1">
              <img
                src={qr}
                alt={`Pobierz 2FAS — ${label}`}
                className="h-[104px] w-[104px] object-contain"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
            </div>
            <Button asChild size="sm" variant="outline" className="h-7 w-full text-xs">
              <a href={url} target="_blank" rel="noopener noreferrer">
                <Icon className="mr-1.5 h-3.5 w-3.5" />
                {store}
              </a>
            </Button>
          </div>
        ))}
      </div>

      <p className="mt-2 text-xs text-muted-foreground">
        Możesz też użyć innej aplikacji: Google Authenticator, Microsoft Authenticator, Aegis, 1Password.
      </p>
    </div>
  );
}

export default RecommendedAuthApp;
